import types from '../types';

const admins = (
  state = {
    data: null,
    permissions: null,
    loading: true,
  },
  { type, payload },
) => {
  switch (type) {
    case types.GET_ADMINS_START:
      return { ...state, loading: true };

    case types.GET_PERMISSIONS_SUCCESS:
      return { ...state, permissions: payload };

    case types.GET_ADMINS_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_ADMINS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default admins;
